module.exports = __webpack_public_path__ + "static/media/example-2.7df6d0fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BusinessNews/example-2.jpg
// module id = 276
// module chunks = 0